import React from 'react';
import '../../styles/horeca/horecaabout.css';
import image from '../../assets/horeca-about.png'
import AnimatedArrowButton from '../AnimatedArrowButton';
import AnimationBox from '../../animationBox';
import { useLocation } from 'react-router-dom';

const HorecaAbout =()=>{
const location = useLocation();
    const value = location.pathname=='/Horeca-Home'?true:false;
    return(

        <div className='horeca-about'>
            <AnimationBox>
        <div className='horeca-about-inner'>
        
        <h4 style={{color:'#FFD52B'}}>About Us</h4>
        <hr></hr>
        <h1 className='mt-5' style={{fontWeight:'600'}}>Who We Are?</h1>
        <p style={{color:'white', fontSize:'0.9rem',marginTop:'1rem'}}>Co6 Group is a leading supplier of premium foodstuff for the hospitality industry, catering to hotels, restaurants, and catering services worldwide. Headquartered in Abu Dhabi, UAE, and founded in 2022, we pride ourselves on our commitment to quality and customer satisfaction. From fresh produce and meats to gourmet ingredients, our offerings empower culinary professionals to create exceptional dining experiences.</p>
        <div className='row'>
            <div className='col-12 col-md-6' style={{maxHeight:'300px', overflow:'hidden',borderRadius:'10px'}}>
                <img src={image} style={{objectPosition:'center' ,height:'300px',objectFit:'cover',width:'100%',borderRadius:'10px'}}></img>
            </div>
            <div  className='col-12 col-md-6'>
            <div className='mx-3'>
            <h1 className='mt-5' style={{fontWeight:'600'}}>Our Mission</h1>
            <p style={{color:'white', fontSize:'0.9rem',marginTop:'1rem'}}>To be the go-to supplier for the hospitality industry by delivering exceptional quality, service, and innovative solutions. Vision: “To set a global benchmark for foodstuff supplies, contributing to the success of our clients’ operations.</p>
            {value?(<AnimatedArrowButton text="Learn More" link="/Horeca-AboutUs"   />):(<AnimatedArrowButton text="Our Products" link="/Horeca-Products"   />)}
            </div>
            </div>
        </div>
        </div>
        </AnimationBox>
        </div>
    );

}


export default HorecaAbout;